import { PostApiMethod } from "./apiService";

export const userlogin = (email: string, password: string, admin: any) => {
    const loginas = admin ? "admin" : "tenant";
    return PostApiMethod(`${loginas}/auth/login`, {
        email,
        password,
    }).then((response: any) => {
        if (response.data.accessToken) {
            localStorage.setItem("access_Token", response.data.accessToken);
        }
        return response.data;
    });
};


export const isLogin = () => {
    if (localStorage.getItem("access_Token")) {
        return true;
    }
    return false;
};
